import React from 'react';
export function Pricing() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3312">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3313">
        <div className="mb-16" data-id="element-3314">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3315">
            Round Pricing
          </h2>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3316">
            <div className="overflow-x-auto" data-id="element-3317">
              <table className="w-full text-left border-collapse" data-id="element-3318">
                <thead data-id="element-3319">
                  <tr style={{
                  backgroundColor: '#1e3d2f'
                }} data-id="element-3320">
                    <th className="p-4 md:p-5 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#ffffff',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3321">
                      Item
                    </th>
                    <th className="p-4 md:p-5 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#c8a84b',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3322">
                      Members
                    </th>
                    <th className="p-4 md:p-5 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#ffffff',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3323">
                      Non-Members
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-3324">
                  <tr className="border-t" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-3325">
                    <td className="p-4 md:p-5 font-medium" style={{
                    color: '#1a1a1a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3326">
                      Sporting Clays (Per Clay thrown)
                    </td>
                    <td className="p-4 md:p-5 font-bold" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3327">
                      $0.34
                    </td>
                    <td className="p-4 md:p-5 font-medium" style={{
                    color: '#4a4a4a',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3328">
                      $0.50
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>;
}